import { StyledHeadingSectionBanner } from './styled';

const HeadingBannerSection = ({ heading, subheading }) => (
  <StyledHeadingSectionBanner>
    <h1 className="cta-heading">{typeof heading === 'function' ? heading() : heading}</h1>
    {subheading && (
      <div className="lead">{typeof subheading === 'function' ? subheading() : subheading}</div>
    )}
  </StyledHeadingSectionBanner>
);

export default HeadingBannerSection;
